import { useEffect, useState } from 'react';
import {
  computeAppFit,
  type AppFit,
} from '../../infrastructure/runtime/fitViewport';

/** App fit scale + on-screen size (resize + visualViewport). */
export function useAppFit(): AppFit {
  const [fit, setFit] = useState(() => computeAppFit());

  useEffect(() => {
    const update = () => setFit(computeAppFit());

    update();
    window.addEventListener('resize', update);
    window.visualViewport?.addEventListener('resize', update);
    return () => {
      window.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('resize', update);
    };
  }, []);

  return fit;
}
